const APP_STORE_URL = "https://apps.apple.com/gb/app/forkto-simplify-food-safety/id6451446254";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.forkto.app";
const APP_WEBSITE_URL = "https://forkto.app";

export function appDownloadUrl(navigatorLike = globalThis.navigator) {
    const identity = `${navigatorLike?.userAgentData?.platform || ""} ${navigatorLike?.platform || ""} ${navigatorLike?.userAgent || ""}`;

    if (/android/i.test(identity)) return GOOGLE_PLAY_URL;

    // iPadOS can identify as a Mac when requesting desktop websites.
    const desktopIPad = /mac/i.test(identity) && navigatorLike?.maxTouchPoints > 1;
    if (/iphone|ipad|ipod|ios/i.test(identity) || desktopIPad) return APP_STORE_URL;

    return APP_WEBSITE_URL;
}
